import { ApiError } from '../api';
import { OTEL_TEKLIF_METIN as M } from '../metin/otelTeklif';
import type { Dil, MusaitlikCevabi, MusaitlikIstegi, OtelBilgisi, OtelOzeti, PdfIstegi } from './tipler';

const KOK = '/api/v1/otel-teklif';

async function hataFirlat(response: Response): Promise<never> {
  const body = await response.json().catch(() => ({}));
  const failure = body as { message?: string | string[]; detail?: string; code?: string; correlationId?: string; reason?: string };
  throw new ApiError(response.status, (Array.isArray(failure.message) ? failure.message.join('. ') : failure.message ?? failure.detail ?? failure.reason) || M.hata, failure.code, failure.correlationId, failure.reason);
}

/** api.ts ile aynı oturum ve CSRF deseni. İptal sinyali tüm çağrılara taşınır. */
async function cagri(yol: string, signal?: AbortSignal, veri?: unknown): Promise<Response> {
  const method = veri === undefined ? 'GET' : 'POST';
  const csrf = /(?:^|;\s*)mbd_csrf=([^;]+)/.exec(document.cookie)?.[1];
  const response = await fetch(`${KOK}${yol}`, {
    method, signal, credentials: 'include',
    headers: { 'content-type': 'application/json', ...(method === 'POST' ? { 'x-csrf-token': csrf ? decodeURIComponent(csrf) : '' } : {}) },
    ...(veri === undefined ? {} : { body: JSON.stringify(veri) }),
  });
  if (!response.ok) return hataFirlat(response);
  return response;
}

export const otelTeklifApi = {
  ara: async (q: string, signal?: AbortSignal): Promise<{ sonuclar: OtelOzeti[] }> => (await cagri(`/oteller?q=${encodeURIComponent(q)}`, signal)).json(),
  otel: async (slug: string, dil: Dil, signal?: AbortSignal): Promise<OtelBilgisi> => (await cagri(`/oteller/${encodeURIComponent(slug)}?dil=${dil}`, signal)).json(),
  musaitlik: async (slug: string, istek: MusaitlikIstegi, signal?: AbortSignal): Promise<MusaitlikCevabi> => (await cagri(`/oteller/${encodeURIComponent(slug)}/musaitlik`, signal, istek)).json(),
  pdf: async (istek: PdfIstegi, signal?: AbortSignal): Promise<{ blob: Blob; dosyaAdi: string }> => {
    const response = await cagri('/pdf', signal, istek);
    const ad = /filename="([^"]+)"/.exec(response.headers.get('content-disposition') ?? '')?.[1] ?? 'otel-teklifi.pdf';
    return { blob: await response.blob(), dosyaAdi: ad };
  },
};
